webpackJsonp([17],{

/***/ "1D0u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Ik1C");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63d2f76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("ZcM6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63d2f76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ik1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      page: '',
      randomImage: 0,
      people: [{ name: 'Will', file: 'will', shape: 'circle', bgColor: '#000', fontColor: '#FFF' }, { name: 'Rebecca', file: 'rebecca', shape: 'circle', bgColor: '#DEC4A5', fontColor: '#0E2969' }, { name: 'John', file: 'john', shape: '', bgColor: '#DCAB33', fontColor: '#FFFFFF' },
      // {name: 'Alan', file: 'alan', shape: '', bgColor: '#799DAD', fontColor: '#000000'},
      { name: 'Ben', file: 'ben', shape: '', bgColor: '#FF6600', fontColor: '#FFFFFF' }, { name: 'Garry', file: 'garry', shape: 'circle', bgColor: '#222946', fontColor: '#FFFFFF' }, { name: 'Rob', file: 'rob', shape: '', bgColor: '#D12828', fontColor: '#F2D600' }, { name: 'Tom', file: 'tom', shape: 'circle', bgColor: '#00CEFF', fontColor: '#FFFFFF' }, { name: 'Alan', file: 'alanc', shape: '', bgColor: '#c6d73f', fontColor: '#FFFFFF' }, { name: 'Bec', file: 'bec', shape: 'circle', bgColor: '#F5C573', fontColor: '#932A35' }]
    };
  },
  created: function created() {
    var _this = this;

    window.api.get('get-pages/about').then(function (res) {
      _this.page = res.data.data.page;
      _this.randomImage = Math.floor(Math.random() * _this.page.header_image.length);
    });
    window.api.get('get-pages-by-type/2').then(function (res) {
      _this.projects = res.data.data;
    }).then(function () {
      _this.$setTweens();
    });
    this.$setSeo('Website Design and Graphic Designers based in the midlands - Derby - UK | Alt Design', 'Design Consultancy and web design, graphic design and logo design in Derby');
  },
  mounted: function mounted() {
    this.animateTeam();
  },

  methods: {
    animateTeam: function animateTeam() {
      var triggered = false;

      window.addEventListener('scroll', function () {
        var entryHeader = document.querySelector('.team-grid').getBoundingClientRect();
        var windowHeight = window.screen.height;

        if (entryHeader.top <= windowHeight / 2) {
          if (!triggered) {
            triggered = true;

            var teamMembers = document.querySelectorAll('.team .person');

            Array.prototype.forEach.call(teamMembers, function (el, index) {
              var that = el;
              index = index + 1;

              setTimeout(function () {
                that.classList.toggle('hover');
              }, 150 * index);

              setTimeout(function () {
                that.classList.toggle('hover');
              }, 750 + 150 * index);
            });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "ZcM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"studio-page page type-page status-publish hentry"},[_c('header',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.page.header_image[_vm.randomImage]),expression:"'https://api.alt-design.net/api/image/' + page.header_image[randomImage]",arg:"background-image"}],staticClass:"entry-header"},[_c('p',{staticClass:"sectors"},[_vm._v(_vm._s(_vm.page.sub_title))]),_vm._v(" "),_c('h1',{staticClass:"entry-title"},[_vm._v(_vm._s(_vm.page.title || 'About'))])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h2',{staticClass:"alt-title"},[_vm._v("Friendly, Down-to-earth, Honest.")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("We design things that look good, and develop ideas that work.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"alt-title"},[_vm._v("Meet The Team")]),_vm._v(" "),_c('div',{staticClass:"team team-grid"},[_vm._l((_vm.people),function(person){return _c('div',{staticClass:"person",class:person.shape},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"front",staticStyle:{"color":"#FFFFFF","background-color":"#000000"},style:({color: person.fontColor, backgroundColor: person.bgColor})},[_c('span',[_vm._v(_vm._s(person.name))])]),_vm._v(" "),_c('div',{staticClass:"back",class:'image-'+person.file})])])}),_vm._v(" "),_vm._l((_vm.people.length % 4),function(n){return _c('div',{staticClass:"person empty"})})],2),_vm._v(" "),_c('div',{staticClass:"services"},[_c('h2',{staticClass:"alt-title"},[_vm._v("So what can we do?")]),_vm._v(" "),_c('p',{staticClass:"intro wrapper",staticStyle:{"text-align":"center"}},[_vm._v("\n                Whether it’s branding from scratch for a small start-up company with great ideas or a reliable e-commerce store for multinational brands with big plans, we have the expertise to help you achieve the best creative solution.\n            ")]),_vm._v(" "),_c('div',{staticClass:"links wrapper"},[_c('div',{staticClass:"team team-grid"},[_c('router-link',{staticClass:"person circle",attrs:{"to":"/about/branding"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"front",staticStyle:{"color":"#FFFFFF","background-color":"#FF6C00"}},[_c('span',[_vm._v("Branding")])]),_vm._v(" "),_c('div',{staticClass:"back back-branding"})])]),_vm._v(" "),_c('router-link',{staticClass:"person circle",attrs:{"to":"/about/print"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"front",staticStyle:{"color":"#FFFFFF","background-color":"#FF6C00"}},[_c('span',[_vm._v("Print")])]),_vm._v(" "),_c('div',{staticClass:"back back-print"})])]),_vm._v(" "),_c('router-link',{staticClass:"person circle",attrs:{"to":"/about/digital"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"front",staticStyle:{"color":"#FFFFFF","background-color":"#FF6C00"}},[_c('span',[_vm._v("Digital")])]),_vm._v(" "),_c('div',{staticClass:"back back-digital"})])])],1)])]),_vm._v(" "),_c('div',{staticClass:"gallery"},[_c('div',{staticClass:"row bottom"},[_c('div',{staticClass:"left equal animateIn"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('https://api.alt-design.net/api/image/' + _vm.page.work_image[0]),expression:"'https://api.alt-design.net/api/image/' + page.work_image[0]"}]})]),_vm._v(" "),_c('div',{staticClass:"right equal animateIn"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('https://api.alt-design.net/api/image/' + _vm.page.work_image[1]),expression:"'https://api.alt-design.net/api/image/' + page.work_image[1]"}]})])]),_vm._v(" "),_c('div',{staticClass:"row top"},[_c('div',{staticClass:"left wide animateIn"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('https://api.alt-design.net/api/image/' + _vm.page.work_image[2]),expression:"'https://api.alt-design.net/api/image/' + page.work_image[2]"}]})]),_vm._v(" "),_c('div',{staticClass:"right narrow animateIn"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('https://api.alt-design.net/api/image/' + _vm.page.work_image[3]),expression:"'https://api.alt-design.net/api/image/' + page.work_image[3]"}]})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cols"},[_c('div',{staticClass:"col left"},[_c('p',{staticClass:"intro"},[_vm._v("We pride ourselves on long lasting client relationships. We may have the numbers of a small studio, but we certainly don’t think small.")])]),_vm._v(" "),_c('div',{staticClass:"col right"},[_c('p',[_vm._v("Midlands based, we enjoy a real mix of clients, from local boutiques and businesses to multinational big hitters. Evolving from one, to many over the past decade, we’re a talented team with broad scope, both technical and creative, who offer professional bespoke brand, print and digital services.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.7fa6f21e31254c36e482.js